import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'warning' | 'danger';

interface Props { tone?: Tone; title?: string; children?: ReactNode }

export function Alert({ tone = 'info', title, children }: Props) {
  return (
    <div className={`alert alert-${tone}`} role={tone === 'danger' ? 'alert' : 'status'}>
      <div className="ico" aria-hidden>
        {tone === 'success' ? '✓' : tone === 'warning' || tone === 'danger' ? '!' : 'i'}
      </div>
      <div className="body">
        {title && <div className="title">{title}</div>}
        {children && <div className="desc">{children}</div>}
      </div>
    </div>
  );
}
